import i18n from 'i18n-js';

import {
  ControllerPs4Pampling,
  ControllerPs5Pampling,
  CountdownPampling,
  MediaLoopSimple,
} from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const PAMPLING_COMPONENTS = {
  [TEMPLATES_TITLES.CONTROLLER_PS4PAMPLING]: ControllerPs4Pampling,
  [TEMPLATES_TITLES.CONTROLLER_PS5PAMPLING]: ControllerPs5Pampling,
  [TEMPLATES_TITLES.COUNTDOWN_PAMPLING]: CountdownPampling,
  [TEMPLATES_TITLES.MEDIALOOP_PAMPLING]: MediaLoopSimple,
  [TEMPLATES_TITLES.MEDIALOOP_PAMPLINGWHITE]: MediaLoopSimple,
};

export const PAMPLING_DESIGNS_DATA = {
  [TEMPLATES_TITLES.CONTROLLER_PS4PAMPLING]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.legsColor'),
          value: 'legs',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.buttonsColor'),
          value: 'buttons',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.buttonColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.backButtons'),
          value: 'backButtons',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.arrowsColor'),
          value: 'arrows',
          items: [
            {
              id: 400,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 401,
              label: i18n.t('screens.builder.design.outerArrowsColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 402,
              label: i18n.t('screens.builder.design.arrowsColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.sticksColor'),
          value: 'sticks',
          items: [
            {
              id: 500,
              label: i18n.t('screens.builder.design.outsideColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 501,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.insideColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 6,
          title: i18n.t('screens.builder.design.optionButtons'),
          value: 'options',
          items: [
            {
              id: 600,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 7,
          title: i18n.t('screens.builder.design.psButton'),
          value: 'ps',
          items: [
            {
              id: 700,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 701,
              label: i18n.t('screens.builder.design.psColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 8,
          title: i18n.t('screens.builder.design.touchPanel'),
          value: 'touchpad',
          items: [
            {
              id: 800,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 9,
          title: i18n.t('screens.builder.design.activatedButton'),
          value: 'active',
          items: [
            {
              id: 900,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.CONTROLLER_PS5PAMPLING]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.bodyColor'),
          value: 'body',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.buttonsColor'),
          value: 'buttons',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.buttonColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.backButtons'),
          value: 'backButtons',
          items: [
            {
              id: 300,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.arrowsColor'),
          value: 'arrows',
          items: [
            {
              id: 400,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 401,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 5,
          title: i18n.t('screens.builder.design.sticksColor'),
          value: 'sticks',
          items: [
            {
              id: 500,
              label: i18n.t('screens.builder.design.outsideColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 501,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
            {
              id: 502,
              label: i18n.t('screens.builder.design.insideColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
        {
          id: 6,
          title: i18n.t('screens.builder.design.optionButtons'),
          value: 'options',
          items: [
            {
              id: 600,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 601,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 7,
          title: i18n.t('screens.builder.design.psButton'),
          value: 'ps',
          items: [
            {
              id: 700,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 701,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 8,
          title: i18n.t('screens.builder.design.touchPanel'),
          value: 'touchpad',
          items: [
            {
              id: 800,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'background',
            },
            {
              id: 801,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'border',
            },
          ],
        },
        {
          id: 9,
          title: i18n.t('screens.builder.design.activatedButton'),
          value: 'active',
          items: [
            {
              id: 900,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'color',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.COUNTDOWN_PAMPLING]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.timer'),
          value: 'timer',
          items: [
            {
              id: 100,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 101,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 102,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 40,
              max: 120,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 103,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.title'),
          value: 'title',
          items: [
            {
              id: 200,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'color',
            },
            {
              id: 201,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'font',
            },
            {
              id: 202,
              label: i18n.t('screens.builder.design.fontSize'),
              min: 20,
              max: 60,
              step: 5,
              type: 'slider',
              value: 'size',
            },
            {
              id: 203,
              label: i18n.t('screens.builder.design.letterSpacing'),
              min: 0,
              max: 30,
              step: 1,
              type: 'slider',
              value: 'letterSpacing',
            },
          ],
        },
      ],
    },
  },
  [TEMPLATES_TITLES.MEDIALOOP_PAMPLING]: {
    design: {},
  },
  [TEMPLATES_TITLES.MEDIALOOP_PAMPLINGWHITE]: {
    design: {},
  },
};

export default {
  PAMPLING_COMPONENTS,
  PAMPLING_DESIGNS_DATA,
};
